module.exports = __webpack_public_path__ + "media/images/responsive/page_common/logo/logo_decollte_black-986321001462f2e49aceada7d5e5adc5.svg";